import * as React from 'react';
import styled, { useTheme } from 'styled-components';
import { Anchor, Flex, Text } from '../../../components/blocks';

import Paper from '../../../images/banner/img-paper.png';

const Root = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
  padding: ${({ theme }) => theme.spaces.xl};
  max-width: ${({ theme }) => theme.windowSizes.m};
  background: ${({ theme }) => theme.backgroundColors.primary};
  border-radius: ${({ theme }) => theme.radii.m};
  gap: ${({ theme }) => theme.spaces.xl};

  ${({ theme }) =>
    theme.screen.sp({
      flexDirection: 'column',
    })}
`;

const ImageWrap = styled.div`
  border: 2px solid ${({ theme }) => theme.borderColors.white};
`;

export const DocumentBanner: React.VFC = () => {
  const theme = useTheme();

  return (
    <Root>
      <ImageWrap>
        <img src={Paper} alt="Dentis資料" width="120px" height="auto" />
      </ImageWrap>
      <Flex flexDirection="column" alignItems="flex-start">
        <Text
          as="h2"
          color="white"
          size="l"
          fontWeight="bold"
          mb={theme.spaces.m}
        >
          <ruby>
            Dentis<rt>デンティス</rt>
          </ruby>
          がよりわかる資料を無料進呈中
        </Text>
        <Text color="white" fontWeight="bold" size="s" lineHeight="l">
          Dentisの活用方法や機能・特長についてわかりやすく解説した資料を無料贈呈中
        </Text>
      </Flex>
      <Anchor color="secondary" to="/form/document" radius="rounded" wide="l">
        資料ダウンロード
      </Anchor>
    </Root>
  );
};
